import { FC, useCallback } from 'react';
import { Box, Button } from '@mui/material';
import appsflyerLogo from '../../../../../assets/icons/appsflyer-logo.png';
import adjustLogo from '../../../../../assets/icons/adjust-logo.png';
import googleDriveLogo from '../../../../../assets/icons/google-drive-logo.png';
import snowFlakeLogo from '../../../../../assets/icons/snowflake-logo.png';
import bigQueryLogo from '../../../../../assets/icons/big-query-logo.png';
import gcsLogo from '../../../../../assets/icons/gcs-logo.png';
import s3Logo from '../../../../../assets/icons/s3-logo.png';
import mySqlLogo from '../../../../../assets/icons/mysql-logo.png';
import aggregatedCohortDataLogo from '../../../../../assets/icons/aggregated-cohort-data-icon.png';
import { DataAccessProvider } from '@constants/constants';

interface DataAccessCardHeaderProps {
  provider: any;
  handleGrantAccessOpen: any;
  showLearnHow: boolean;
}

const DataAccessCardHeader: FC<DataAccessCardHeaderProps> = ({
  provider,
  handleGrantAccessOpen,
  showLearnHow,
}) => {
  const getProviderDetails = useCallback(() => {
    switch (provider) {
      case DataAccessProvider.APPS_FLYER:
        return { iconUrl: appsflyerLogo, label: 'AppsFlyer' };
      case DataAccessProvider.ADJUST:
        return { iconUrl: adjustLogo, label: 'Adjust' };
      case DataAccessProvider.BIGQUERY:
        return { iconUrl: bigQueryLogo, label: 'BigQuery' };
      case DataAccessProvider.GCS:
        return { iconUrl: gcsLogo, label: 'Google Cloud Storage' };
      case DataAccessProvider.S3:
        return { iconUrl: s3Logo, label: 'Amazon S3' };
      case DataAccessProvider.MYSQL:
        return { iconUrl: mySqlLogo, label: 'My SQL' };
      case DataAccessProvider.SNOWFLAKE:
        return { iconUrl: snowFlakeLogo, label: 'Snowflake' };
      case DataAccessProvider.GOOGLE_DRIVE:
        return {
          iconUrl: googleDriveLogo,
          label: 'Direct File Share (Cloud Storage Link)',
        };
      case DataAccessProvider.AGGREGATED_DATA:
        return {
          iconUrl: aggregatedCohortDataLogo,
          label: 'Aggregated Cohort Data',
        };
      case DataAccessProvider.NONE:
        return { iconUrl: undefined, label: 'Other' };
      default:
        return { iconUrl: undefined, label: 'Other' };
    }
  }, [provider]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          background: 'transparent',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          justifyContent: 'center',
          color: '#162936',
          fontSize: '0.875rem',
          fontWeight: 700,
          lineHeight: '1.25rem',
          letterSpacing: '-0.35px',
        }}
      >
        {getProviderDetails().iconUrl && (
          <img height={'100%'} src={getProviderDetails().iconUrl || ''} alt={`logo-${provider}`} />
        )}
        {getProviderDetails().label}
      </Box>
      {showLearnHow && (
        <Button
          disableElevation
          disableFocusRipple
          disableRipple
          disableTouchRipple
          onClick={handleGrantAccessOpen}
          sx={{
            color: '#51B8B0',
            textDecoration: 'underline',
            textTransform: 'none',
            fontSize: '0.85rem',
            lineHeight: '1rem',
            fontWeight: 700,
            padding: 0,
            ':hover': {
              background: 'none',
            },
          }}
        >
          Learn How
        </Button>
      )}
    </Box>
  );
};

export default DataAccessCardHeader;
